import {
  LABORDENDIGITAL_GETPDF_ERROR,
  LABORDENDIGITAL_GETPDF_LOADING,
  LABORDENDIGITAL_GETPDF_RESET,
  LABORDENDIGITAL_GETPDF_SUCCESS,
} from "_+_Portal/context/ActionTypes";
import axiosLogin from "global/helpers/axiosLogin";
import axiosInstance from "global/helpers/axiosInstance";

/* export const wsGetPDFOrdenDigital = (idPacFamiliar, nextStep) => (dispatch) => {
  dispatch({
    type: LABORDENDIGITAL_GETPDF_LOADING,
  });

  axiosInstance().then((respuesta) => {
    respuesta
      .get(`/LabOrdenDigital/GetPDF/${idPacFamiliar}`)
      .then((res) => {
        const data = res?.data;
        dispatch({
          type: LABORDENDIGITAL_GETPDF_SUCCESS,
          payload: data,
        });
        if (typeof nextStep === "function") nextStep(true, data);
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
        };

        dispatch({
          type: LABORDENDIGITAL_GETPDF_ERROR,
          payload: error,
        });
        if (typeof nextStep === "function")
          nextStep(false, err.response ? err.response.data : error.detail);
      });
  });
};
 */
export const wsGetPDFOrdenDigital =
  (idOrdenDigital, nextStep) => (dispatch) => {
    dispatch({ type: LABORDENDIGITAL_GETPDF_LOADING });
    axiosLogin().then((respuesta) => {
      respuesta
        .get(`lis/laboratorio/ordendigital/GetPDF/${idOrdenDigital}/pdf`, {
          responseType: "blob",
        })
        .then((resp) => {
          const blob = resp.data;
          dispatch({
            type: LABORDENDIGITAL_GETPDF_SUCCESS,
            payload: null,
          });
          if (nextStep) nextStep(true, { blob });
        })
        .catch((err) => {
          dispatch({ type: LABORDENDIGITAL_GETPDF_ERROR, payload: err.data });
          if (nextStep) nextStep(false, err.response.data);
        });
    });
  };

export const resetPDFOrdenDigital = () => (dispatch) => {
  dispatch({
    type: LABORDENDIGITAL_GETPDF_RESET,
  });
};
